import React, {useContext} from 'react'
import {Form, Input} from "antd";
import {RecipeConText} from "../../../../../context/RecipeContext";

const { TextArea } = Input

const RecipeDescription = () => {
    const {recipeAbstract} = useContext(RecipeConText)
    const [abstractState, setAbstractState] = recipeAbstract

    const handleInputChange = (event) => {
        let mockAbstract = Object.assign({}, abstractState)
        mockAbstract.description = event.target.value
        setAbstractState(mockAbstract)
    }

    return(
        <React.Fragment>
                <Form.Item
                    className={'font-bold'}
                    label={'Reçete Açıklaması'}
                    name={'recipeDescription'}
                    onChange={handleInputChange}
                    labelAlign={'left'}
                >
                    <TextArea style={{minWidth: '250px'}} />
                </Form.Item>
        </React.Fragment>
    )
}
export default RecipeDescription